import { RouteObject } from "react-router"
import PacienteList from "./view/paciente.list"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../config/data.types"
import { Groups, MenuOpen } from "@mui/icons-material"


export enum PathRotaPaciente {
    paciente = "/paciente"
}

const routerPaciente: RouteObject = {
    path: PathRotaPaciente.paciente,
    element: <PacienteList/>,
}


export const navigationToPacienteView = ()=> rotas.navigate(PathRotaPaciente.paciente)

export function startRouterPaciente(){
    const menu:MainMenu = {
        text:"Recepção Pacientes",
        icon:<Groups />,
        eventOnClick:navigationToPacienteView
    }
    menuRotas.push(menu);
    return routerPaciente
}